import { WebpEgwBlackLogo } from '@egw/assets'
import { type TFunction } from '@egw/i18n'
import { jsPDF } from 'jspdf'
import { autoTable } from 'jspdf-autotable'

type jsPDFType = any

interface GeneratePDFDownloadProps {
  routingNumber?: string
  accountNumber?: string
  addressLine1?: string
  addressLine2?: string
  addressCity?: string
  addressRegionCode?: string
  addressPostalCode?: string
  firstName?: string
  lastName?: string
  t: TFunction<'features-enrollment'>
}

export const GeneratePDFDownload = ({
  routingNumber,
  accountNumber,
  addressLine1,
  addressLine2,
  addressCity,
  addressRegionCode,
  addressPostalCode,
  firstName,
  lastName,
  t,
}: GeneratePDFDownloadProps): void => {
  // eslint-disable-next-line new-cap
  const doc = new jsPDF('p', 'mm', 'a4') as unknown as jsPDFType

  const image = new Image()
  image.src = WebpEgwBlackLogo

  doc.addImage(image, 'PNG', 10, 10, 120, 8)

  const h1 = t('multi.wire_instructions_pdf.h1')
  const p1 = t('multi.wire_instructions_pdf.p1')
  const p2 = t('multi.wire_instructions_pdf.p2')
  const p3 = t('multi.wire_instructions_pdf.p3')
  const p4 = t('multi.wire_instructions_pdf.p4')
  const p4_5 = t('multi.wire_instructions_pdf.p4_5')
  const h2 = t('multi.wire_instructions_pdf.wire_instructions')

  doc.setFontSize(15)
  doc.setFont('Helvetica', 'bold')

  doc.text(h1, 10, 30)

  doc.setFontSize(11)
  doc.setFont('Helvetica', 'normal')
  const splitp1 = doc.splitTextToSize(p1, 180)
  doc.text(10, 40, splitp1)

  const splitp2 = doc.splitTextToSize(p2, 180)
  doc.text(10, 65, splitp2)

  const splitp3 = doc.splitTextToSize(p3, 180)
  doc.text(10, 75, splitp3)

  const splitp4 = doc.splitTextToSize(p4, 180)
  doc.text(10, 95, splitp4)

  doc.setFont('Helvetica', 'bold')
  const splitp4_5 = doc.splitTextToSize(p4_5, 180)
  doc.text(10, 100, splitp4_5)

  doc.setFontSize(15)
  const splith2 = doc.splitTextToSize(h2, 180)
  doc.text(10, 115, splith2)

  const beneficiaryAddressLabel = `${addressLine1}\n${addressLine2 ? `${addressLine2}\n${addressCity}` : `${addressCity}`} ${addressRegionCode}, ${addressPostalCode}`

  // We do the account data table here
  const tableRows = [
    [t('multi.wire_instructions_pdf.bank'), t('multi.wire_instructions_pdf.coastal_community_bank')],
    [t('multi.wire_instructions_pdf.routing_number_label'), routingNumber ?? ''],
    [t('multi.wire_instructions_pdf.account_number_label'), accountNumber ?? ''],
    [t('multi.wire_instructions_pdf.beneficiary_label'), `${firstName} ${lastName}`],
    [t('multi.wire_instructions_pdf.beneficiary_address_label'), beneficiaryAddressLabel],
    [t('multi.wire_instructions_pdf.bank_address_label'), t('multi.wire_instructions_pdf.bank_address')],
    [t('multi.wire_instructions_pdf.memo'), t('multi.wire_instructions_pdf.enter_as_needed')],
  ]

  autoTable(doc, {
    body: tableRows,
    startY: 120,
    bodyStyles: {
      fillColor: [255, 255, 255],
      fontSize: 12, // Adjust the font size for the body
      cellPadding: { top: 5, right: 5, bottom: 5, left: 5 }, // Adjust cell padding
      textColor: [0, 0, 0], // Set text color for the body
    },
  })

  // Save the PDF
  doc.save('wire-transfer-instructions.pdf')
}
